import { Stack, Text, Tooltip } from "@mantine/core";
import SmallTextWithCopy from "../../../../shared/copy/SmallText";
import Dash from "../../../../shared/placeholder/Dash";
import ProfileImg from "../../../../shared/ui/icons/ProfileImg";
import TruncatedTextTooltip from "../../../../shared/ui/truncate/TruncatedText";
import { InformationCircleIcon } from "@heroicons/react/20/solid";

type Props = {
  name?: string,
  email?: string,
  website?:string,
  img?: string,
  id?: string,
  joined?: string,
  totalUsers?: number,
  lastSeen?: string,
};

const AccountProfileAvatar = ({
  name,
  email,
  website,
  img,
  id, 
  joined,
  totalUsers,
  lastSeen,
}: Props) => (
  <Stack gap={12} justify="center" align="center" className="w-full">
    <ProfileImg width={50} height={50} desc={email || website} img={img} name={name} />
    <Stack gap={0} align="center" className="w-full">
      {name && <TruncatedTextTooltip fw={600} width={200} ta="center" size="xl" c="text.9" tooltipText={name}>{name}</TruncatedTextTooltip>}
      {id && <SmallTextWithCopy size="xs" width={110} text={id} />}
        <div className="bg-gray-50 rounded p-2 mt-1 w-full">
          <Stack gap={6} className="w-full">
          <div className="flex items-center justify-between">
          <Text c="text.6" size="xs" className="font-semibold">Joined On</Text>
          {joined ? (
            <Text c="text.6" size="xs" className="font-semibold">{joined}</Text>
          ) : <Dash className="ml-1" />}
        </div>
            <div className="flex justify-between items-center">
                <Text c="text.6" size="xs" className="font-semibold">Total Users</Text>
                {totalUsers ? (
                  <Text c="text.6" size="xs" className="font-semibold italic">{totalUsers}</Text>
                ) : <Dash />}
            </div>

            <div className="flex justify-between items-center">
              <div className="flex items-center gap-1">
                <Text c="text.6" size="xs" className="font-semibold">Last Seen</Text>
                <Tooltip withinPortal label="The last time we received an event for this Company">
                  <InformationCircleIcon className="w-3 h-3 cursor-help hover:text-gray-500 text-gray-400" />
                </Tooltip>
              </div>
                {lastSeen ? (
                  <Text c="text.6" size="xs" className="font-semibold italic">{lastSeen}</Text>
                ) : <Dash />}
            </div>
          </Stack>
        </div>
    </Stack>
  </Stack>
);

export default AccountProfileAvatar;
